import React from 'react'
import { useTranslation } from 'react-i18next'
import Switch, { SwitchProps } from '@mui/material/Switch'
import { styled } from '@mui/material/styles'

interface Props {
  checked: boolean

  onChange(checked: boolean): void
}

const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName='.Mui-focusVisible' disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#005058',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#005058',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: '#E9E9EA',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}))

const SaveAsDefaultKitToggle: React.FC<Props> = ({ checked, onChange }) => {
  const { t } = useTranslation()
  return (
    <div className='flex items-start gap-10'>
      <IOSSwitch
        className='flex-shrink-0'
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <div>
        <div className='font-bold text-lg mb-5'>
          {t('title.saveAsDefaultKitConfiguration', 'Save as Default Kit Configuration')}
        </div>
        <div className='text-base'>
          {t('description.saveAsDefaultKitConfiguration', 'Apply this configuration by default for future orders.')}
        </div>
      </div>
    </div>
  )
}

export default SaveAsDefaultKitToggle
